export default __webpack_public_path__ + "static/media/slider-img9.8afa8f41.jpg";